import backgroundImage from "./background-transparent";

export default theme => ({
  screenPosition: {
    border: `1px solid ${theme.palette.primary.light}`,
    overflow: "hidden",
    margin: "0 auto",
    backgroundImage: `url(${backgroundImage.toString()})`,
    position: "relative",
  },
  screenPosition__image: {
    position: "absolute",
    border: `1px solid ${theme.palette.primary.dark}`,
  },
});
